// Base FR translations (full)
const FR = {
  nav: { home: "Accueil", features: "Fonctionnalités", how: "Comment ça marche", impact: "Impact", contact: "Contact", login: "Se connecter", dashboard: "Tableau de bord", register_hospital: "Inscrire mon hôpital", pitch: "Dossier partenaires" },
  hero: {
    tag: "Startup Santé · République Démocratique du Congo",
    slogan: "La santé en confiance, partout en RDC",
    title1: "Connecter chaque patient",
    title2: "à des soins de qualité",
    subtitle: "KWIKILA Care numérise l'accueil hospitalier en RDC : enregistrement des patients, conseils personnalisés (femmes enceintes, enfants 0-3 ans, troisième âge) et rappels SMS automatiques de rendez-vous. Plateforme multi-hôpitaux sécurisée.",
    cta_primary: "Voir la démo", cta_secondary: "Inscrire mon hôpital",
  },
  problem: { kicker: "Le défi en RDC", title: "Trop de patients perdus dans le système",
    p1: "En République Démocratique du Congo, des milliers de patients manquent leurs rendez-vous médicaux faute de rappels accessibles. Les femmes enceintes et les jeunes enfants n'ont pas accès à des conseils continus de santé après l'accouchement.",
    p2: "Les personnes âgées sont souvent isolées dans leur parcours de soins. Les hôpitaux n'ont pas d'outil simple pour communiquer en masse une campagne de vaccination ou une alerte sanitaire.",
  },
  solution: { kicker: "Notre solution", title: "Un compagnon numérique pour chaque patient",
    desc: "À l'accueil, le secrétariat médical enregistre simplement le numéro de téléphone du patient. KWIKILA Care s'occupe du suivi : rappels, conseils personnalisés, campagnes santé. Chaque hôpital dispose de son propre espace sécurisé.",
  },
  features: { kicker: "Conçu pour la RDC", title: "Pensé pour les besoins réels du terrain",
    pregnant: { t: "Femmes enceintes & 0-3 ans", d: "Conseils continus sur l'alimentation, l'activité, la protection et le suivi vaccinal jusqu'à 3 ans." },
    elderly: { t: "Troisième âge", d: "Recommandations adaptées : nutrition, activité douce, prévention des chutes, lien social." },
    reminders: { t: "Rappels SMS automatiques", d: "Chaque RDV envoie 3 rappels au patient : J-15, J-3 et 45 min avant." },
    campaigns: { t: "Campagnes & publicité santé", d: "L'équipe envoie en un clic une alerte vaccinale ou un message de prévention." },
    multilingual: { t: "5 langues nationales", d: "Français, Lingala, Swahili, Tshiluba, Kikongo : tout le territoire couvert." },
    registry: { t: "Multi-hôpitaux sécurisé", d: "Chaque hôpital a son espace isolé. Transferts patients avec consentement." },
  },
  how: { kicker: "Comment ça marche", title: "Du téléphone à des soins continus",
    s1: { t: "Enregistrement à l'accueil", d: "Le secrétariat saisit nom, âge, téléphone, catégorie et langue." },
    s2: { t: "Suivi automatique", d: "Le patient reçoit un message de bienvenue et des conseils selon son profil." },
    s3: { t: "RDV & rappels", d: "Pour chaque RDV : rappels J-15, J-3 et 45 min. Plus de RDV manqués." },
    s4: { t: "Campagnes ciblées", d: "L'équipe diffuse vaccin, prévention ou pub santé sur les téléphones." },
  },
  impact: { kicker: "Pourquoi maintenant en RDC", title: "Un marché de plus de 100 millions d'habitants",
    stat1: "100M+", stat1l: "Population RDC", stat2: "75%", stat2l: "Pénétration mobile",
    stat3: "5", stat3l: "Langues couvertes", stat4: "0€", stat4l: "Coût pour le patient",
  },
  cta_section: { title: "Devenez partenaire de KWIKILA Care", desc: "Hôpitaux, cliniques, ONG, ministère de la Santé : rejoignez-nous.", btn: "Inscrire mon hôpital", btn2: "Télécharger le dossier" },
  footer: { rights: "Tous droits réservés", made: "Conçu pour la République Démocratique du Congo" },
  auth: { title: "Connexion équipe", email: "Email", password: "Mot de passe", submit: "Se connecter", error: "Identifiants invalides", demo: "Démo Super-Admin: admin@kwikila.cd / admin123" },
  reg: { title: "Inscrire votre hôpital", subtitle: "Rejoignez la plateforme KWIKILA Care. Validation par notre équipe sous 24-48h.",
    h_name: "Nom de l'hôpital", h_city: "Ville", h_email: "Email de contact", h_phone: "Téléphone",
    a_name: "Nom de l'administrateur", a_pw: "Mot de passe (8 car. min.)",
    submit: "Envoyer la demande", success: "Inscription envoyée ! Vous recevrez un email après validation.",
    back: "Retour à l'accueil",
  },
  dash: {
    home: "Tableau de bord", patients: "Patients", appointments: "Rendez-vous", campaigns: "Campagnes",
    advice: "Conseils santé", sms: "Journal SMS", team: "Équipe", audit: "Logs d'audit", logout: "Déconnexion",
    my_day: "Ma journée", hospitalizations: "Hospitalisés", deaths: "Registre décès", subscribe: "Abonnement", hospital: "Hôpital",
    services: "Services", emergency: "Urgences", maternity: "Maternité", pediatrics: "Pédiatrie", pharmacy: "Pharmacie", epidemic: "Alertes épidémie", dhis2: "Rapport SNIS / DHIS2",
    service: "Service", specialty: "Spécialité", caregiver_role: "Aide-soignant(e)",
    welcome: "Bienvenue", overview: "Vue d'ensemble",
    total_patients: "Patients totaux", appts_today: "RDV aujourd'hui", sms_sent: "SMS envoyés", campaigns_sent: "Campagnes",
    by_category: "Patients par catégorie", recent: "Activité récente",
    add_patient: "Ajouter un patient", search: "Rechercher...", all_categories: "Toutes catégories",
    pregnant: "Femme enceinte", child: "Enfant 0-3 ans", elderly: "Troisième âge", general: "Patient général",
    phone: "Téléphone", name: "Nom", age: "Âge", category: "Catégorie", address: "Adresse", language: "Langue", notes: "Notes", actions: "Actions",
    save: "Enregistrer", cancel: "Annuler", delete: "Supprimer",
    new_appt: "Nouveau RDV", patient: "Patient", date: "Date", reason: "Motif", doctor: "Médecin",
    send_reminder: "Envoyer rappel", reminders: "Rappels", status: "Statut",
    new_campaign: "Nouvelle campagne", title_campaign: "Titre", message: "Message", target: "Cible", type: "Type", sent_count: "Envoyés",
    vaccine: "Campagne vaccinale", advert: "Publicité", advice_msg: "Conseil santé",
    generate_ai: "Générer avec IA", topic: "Sujet", static_lib: "Bibliothèque",
    invite_staff: "Inviter un membre", role: "Rôle", admin_role: "Admin hôpital", doctor_role: "Médecin", nurse_role: "Infirmier(e)", secretary_role: "Secrétariat",
    transfer: "Transférer", transfer_title: "Transférer le patient", target_hospital: "Hôpital cible",
    consent: "J'atteste avoir le consentement écrit du patient pour ce transfert", transfer_reason: "Motif (optionnel)",
    medical_notes: "Notes médicales", add_note: "Ajouter une note", note_content: "Contenu de la note",
  },
  super: {
    home: "Vue globale", hospitals: "Hôpitaux", audit: "Logs d'audit",
    total_hospitals: "Hôpitaux", active_hospitals: "Actifs", pending_hospitals: "En attente",
    total_sms: "SMS plateforme",
    new_hospital: "Créer un hôpital", h_status: "Statut", h_plan: "Plan", h_staff: "Équipe", h_patients: "Patients",
    activate: "Activer", deactivate: "Désactiver", approve: "Approuver",
    audit_user: "Utilisateur", audit_action: "Action", audit_target: "Cible", audit_when: "Quand",
  },
  roles: {
    super_admin: "Super-Admin KWIKILA", hospital_admin: "Admin hôpital", doctor: "Médecin", nurse: "Infirmier(e)", caregiver: "Aide-soignant(e)", secretary: "Secrétariat", ministry: "Ministère de la Santé",
  },
};

// Lingala - core overrides, falls back to FR for unset keys
const LN = {
  ...FR,
  nav: { ...FR.nav, home: "Ndako", login: "Kokota", dashboard: "Etando", register_hospital: "Kokoma lopitalo" },
  hero: { ...FR.hero, title1: "Kokangisa moto na moto", title2: "na bonganga ya malamu",
    subtitle: "KWIKILA Care ekomisi accueil ya lopitalo na RDC : kokoma bakambi, batoli, SMS ya rappel.",
    cta_primary: "Talisa demo", cta_secondary: "Kokoma lopitalo",
  },
  auth: { ...FR.auth, title: "Kokota equipe", email: "Email", password: "Motuya ya nkuku", submit: "Kokota" },
  dash: { ...FR.dash, home: "Etando", patients: "Bakambi", appointments: "Ba RDV", campaigns: "Ba campagnes", advice: "Batoli ya bokolongono",
    sms: "Mikanda SMS", team: "Ekipi", audit: "Ba logs", my_day: "Mokolo na ngai", hospitalizations: "Balali na lopitalo", deaths: "Bakufi",
    subscribe: "Abonnement", hospital: "Lopitalo", services: "Ba services", emergency: "Urgences", maternity: "Maternité", pediatrics: "Bana", pharmacy: "Pharmacie",
    pregnant: "Mama ya zemi", child: "Mwana 0-3", elderly: "Mobange", general: "Patient",
    logout: "Kobima", welcome: "Boyei bolamu", add_patient: "Kobakisa patient", search: "Koluka...", all_categories: "Nyonso",
    phone: "Telefone", name: "Nkombo", age: "Mibu", category: "Lolenge", save: "Kobomba", cancel: "Kotika", delete: "Kolongola",
    new_appt: "RDV ya sika", date: "Mokolo", reason: "Ntina", doctor: "Monganga", status: "Ezalela",
  },
  roles: { ...FR.roles, doctor: "Monganga", nurse: "Infirmier", caregiver: "Mosalisi", secretary: "Secrétaire" },
};

// Swahili
const SW = {
  ...FR,
  nav: { ...FR.nav, home: "Nyumbani", login: "Ingia", dashboard: "Dashibodi", register_hospital: "Sajili hospitali" },
  hero: { ...FR.hero, title1: "Kuunganisha kila mgonjwa", title2: "na huduma bora za afya",
    subtitle: "KWIKILA Care inadijitisha mapokezi ya hospitali RDC: usajili, ushauri na SMS.",
    cta_primary: "Tazama demo", cta_secondary: "Sajili hospitali",
  },
  auth: { ...FR.auth, title: "Ingia timu", email: "Barua pepe", password: "Nenosiri", submit: "Ingia" },
  dash: { ...FR.dash, home: "Dashibodi", patients: "Wagonjwa", appointments: "Miadi", campaigns: "Kampeni", advice: "Ushauri wa afya",
    sms: "Kumbukumbu SMS", team: "Timu", audit: "Kumbukumbu", my_day: "Siku yangu", hospitalizations: "Waliolazwa", deaths: "Rejista ya vifo",
    subscribe: "Usajili", hospital: "Hospitali", services: "Huduma", emergency: "Dharura", maternity: "Uzazi", pediatrics: "Watoto", pharmacy: "Famasia",
    pregnant: "Mjamzito", child: "Mtoto 0-3", elderly: "Mzee", general: "Mgonjwa",
    logout: "Toka", welcome: "Karibu", add_patient: "Ongeza mgonjwa", search: "Tafuta...", all_categories: "Vyote",
    phone: "Simu", name: "Jina", age: "Umri", category: "Kundi", save: "Hifadhi", cancel: "Ghairi", delete: "Futa",
    new_appt: "Miadi mpya", date: "Tarehe", reason: "Sababu", doctor: "Daktari", status: "Hali",
  },
  roles: { ...FR.roles, doctor: "Daktari", nurse: "Muuguzi", caregiver: "Msaidizi wa afya", secretary: "Katibu" },
};

// Tshiluba (Kasai)
const TS = {
  ...FR,
  nav: { ...FR.nav, home: "Kuabu", login: "Buela", dashboard: "Tshilumbuluidi", register_hospital: "Funda lupitala" },
  hero: { ...FR.hero, title1: "Kusangisha bantu booso",
    title2: "ku diakalenga dimpe",
    subtitle: "KWIKILA Care ifika kufunda bantu mu lupitala mu RDC : kuela, mibelu, SMS ya kuvuluja.",
    cta_primary: "Tangila demo", cta_secondary: "Funda lupitala",
  },
  auth: { ...FR.auth, title: "Kubuela", email: "Email", password: "Lukulu", submit: "Buela" },
  dash: { ...FR.dash, home: "Tshilumbuluidi", patients: "Bana balwadi", appointments: "Bipungidi", team: "Tshisumbu", hospital: "Lupitala",
    my_day: "Dituku dianyi", hospitalizations: "Badi mu lupitala", deaths: "Bafue", services: "Mudimu", pediatrics: "Bana",
    pregnant: "Mukaji wa muanaa", child: "Muana 0-3", elderly: "Mukulu", general: "Mulwadi",
    logout: "Patuka", welcome: "Walu kuabu", add_patient: "Sakidila mulwadi", search: "Keba...", name: "Dina", age: "Bidimu", phone: "Telefone",
    save: "Lama", cancel: "Lekela", date: "Dituku", doctor: "Munganga",
  },
  roles: { ...FR.roles, doctor: "Munganga", caregiver: "Muambuluishi" },
};

// Kikongo (Bas-Congo / Kongo central)
const KG = {
  ...FR,
  nav: { ...FR.nav, home: "Kuna", login: "Kota", dashboard: "Bilakulu", register_hospital: "Sonika lupitalu" },
  hero: { ...FR.hero, title1: "Kunungisa konso muntu",
    title2: "kuna bisalukulu bya mbote",
    subtitle: "KWIKILA Care ke sadisa kusonika bambefo na lupitalu mu RDC : kusonika, malongi, SMS.",
    cta_primary: "Tala demo", cta_secondary: "Sonika lupitalu",
  },
  auth: { ...FR.auth, title: "Kota na ekipi", email: "Email", password: "Diaka", submit: "Kota" },
  dash: { ...FR.dash, home: "Bilakulu", patients: "Bambefo", appointments: "Mavanga", team: "Kimvuka", hospital: "Lupitalu",
    my_day: "Kilumbu kiame", hospitalizations: "Balele mu lupitalu", deaths: "Bafwa", services: "Bisalu", pediatrics: "Bana",
    pregnant: "Nkento ya divumu", child: "Mwana 0-3", elderly: "Nkulu", general: "Mbefo",
    logout: "Vaika", welcome: "Mboti", add_patient: "Yika mbefo", search: "Sosa...", name: "Nkumbu", age: "Mvula", phone: "Telefone",
    save: "Lunda", cancel: "Yambula", date: "Kilumbu", doctor: "Nganga-nkisi",
  },
  roles: { ...FR.roles, doctor: "Nganga-nkisi", caregiver: "Nsadisi" },
};

export const TRANSLATIONS = { fr: FR, ln: LN, sw: SW, ts: TS, kg: KG };

export const LANGUAGES = [
  { code: "fr", label: "Français", flag: "FR" },
  { code: "ln", label: "Lingala", flag: "LN" },
  { code: "sw", label: "Swahili", flag: "SW" },
  { code: "ts", label: "Tshiluba", flag: "TS" },
  { code: "kg", label: "Kikongo", flag: "KG" },
];
